import React from "react";
import "./App.css";
import { BrowserRouter, Route, Routes} from "react-router-dom";

import "bootstrap/dist/js/bootstrap.bundle.min";

import HomePage from "./components/Home/HomePage";
import BatchDetailPage from "./components/Batches/BatchDetailPage";
import AboutPage from "./components/About/AboutPage";
import TrainingModulePage from "./components/Services/TrainingModule-Components/TrainingModulePage";
import ContactPage from "./components/Contact/ContactPage";
import TrackDetailPage from "./components/Services/TrainingModuleDetail-Components/TrackDetailPage";
import Track1Detail from "./components/Services/TrainingModuleDetail-Components/TrackDetailComponent/Track1Detail";
import Track2Detail from "./components/Services/TrainingModuleDetail-Components/TrackDetailComponent/Track2Detail";
import Track3Detail from "./components/Services/TrainingModuleDetail-Components/TrackDetailComponent/Track3Detail";
import LoginPage from "./components/AuthPages/login/LoginPage";
import ForgotPage from "./components/AuthPages/Forgot/ForgotPage";
import Track1Card from "./components/Services/TrainingModule-Components/TrackComponents/Track1Card";
import Track2Card from "./components/Services/TrainingModule-Components/TrackComponents/Track2Card";
import Track3Card from "./components/Services/TrainingModule-Components/TrackComponents/Track3Card";

const App = () => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="/batchDetails" element={<BatchDetailPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/training" element={<TrainingModulePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/trackDetail" element={<TrackDetailPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgotPassword" element={<ForgotPage />} />

          <Route path="/track1" element={<Track1Card />} />
          <Route path="/track1Detail/:id" element={<Track1Detail />} />

          <Route path="/track2" element={<Track2Card />} />
          <Route path="/track2Detail/:id" element={<Track2Detail />} />

          <Route path="/track3" element={<Track3Card />} />
          <Route path="/track3Detail/:id" element={<Track3Detail />} />

          
        </Routes>
      </BrowserRouter>
    </div>
  );
};


export default App;
